import type { IntlShape } from "react-intl";

export const fmtDateTime = (intl: IntlShape, v: string | Date | null | undefined) =>
  v ? intl.formatDate(v, { dateStyle: "medium", timeStyle: "short" }) : "—";

export const fmtDate = (intl: IntlShape, v: string | Date | null | undefined) =>
  v ? intl.formatDate(v, { dateStyle: "medium" }) : "—";

/** Platzhalter für fehlende Werte und Trenner in Listenzeilen (sprachneutral). */
export const EMPTY = "—";
export const SEP = " · ";
export const joinParts = (...parts: Array<string | null | undefined | false>) =>
  parts.filter(Boolean).join(SEP);
